import { render, staticRenderFns } from "./academic_font_management.vue?vue&type=template&id=5fd6a4bc&scoped=true&"
import script from "./academic_font_management.vue?vue&type=script&lang=js&"
export * from "./academic_font_management.vue?vue&type=script&lang=js&"
import style0 from "./academic_font_management.vue?vue&type=style&index=0&id=5fd6a4bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd6a4bc",
  null
  
)

export default component.exports